<template>
    <el-time-select v-bind="$attrs" placeholder="" :value="value" @input="change" :picker-options="options"></el-time-select>
</template>

<style lang="scss">
    /*.custom-time-picker {
        &.el-date-editor {
            width: 100% !important;
            padding: 0 !important;

        }

        .el-input__inner {
            line-height: normal !important;
            padding: 8px 12px 8px 35px !important;
            border-radius: 0 !important;
            border: 0 !important;
            height: auto;
        }

        .el-input__icon {
            line-height: normal !important;
        }
    }

    .el-picker-panel {
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border-radius: 0 !important;
    }*/
</style>

<script>
export default {
  props: {
    value: {},
    options: {
      type: Object,
      default: () => ({
        start: '00:00',
        step: '00:15',
        end: '23:45'
      })
    }
  },
  methods: {
    change (value) {
      this.$emit('input', value)
    }
  }
}
</script>
